import { useEffect, useMemo, useState } from "react";
import { useGlobalConfigs } from "@infrastructure/Hooks/useGlobalConfigs";
import { useMainGroupSelectorStore } from "./MainGroupSelectorStore";

type GlobalConfigsGroupType = {
    id: string;
    isFilter: string;
    label: string;
};

export function useGroupSelector() {
    const { getConfigs } = useGlobalConfigs();
    const tippspielFeedGroups = getConfigs()?.tippspielFeedGroups;

    const [filters, setFilters] = useState<string[]>();
    const { mainGroupId, setMainGroupId } = useMainGroupSelectorStore();

    useEffect(() => {
        if (!tippspielFeedGroups) {
            return;
        }

        const parsedGroups = JSON.parse(
            tippspielFeedGroups,
        ) as GlobalConfigsGroupType[];
        const groups: GlobalConfigsGroupType[] = parsedGroups.filter(
            (value) => value.id,
        );

        if (groups.length === 0) {
            return;
        }

        setFilters(groups.map((item) => item.id));
        setMainGroupId(
            groups
                .filter((item) => item.isFilter === "0")
                .map((item) => item.id)[0],
        );
    }, [tippspielFeedGroups, setMainGroupId]);

    const preparedFiltersForPost = useMemo(
        () => ({
            selectedGroups: filters,
        }),
        [filters],
    );

    return {
        filters,
        mainGroupId,
        preparedFiltersForPost,
    };
}
